<template lang="">
  <div>
    <div class="container">
      <div class="main-result">
        <Form :model="formItem" :label-width="80">
          <FormItem label="企业代码">
            <Input
              @click="SelectClientSwitch = !SelectClientSwitch"
              v-model="formItem.clientcode"
              type="text"
              placeholder="企业代码"
            ></Input>
          </FormItem>
          <FormItem label="首次查询">
            <Input
              v-model="formItem.Ares"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="首次查询回复..."
            ></Input>
          </FormItem>

          <FormItem label="重复查询">
            <Input
              v-model="formItem.Bres"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="重复查询回复..."
            ></Input>
          </FormItem>

          <FormItem label="多次查询">
            <Input
              v-model="formItem.Cres"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="多次查询回复..."
            ></Input>
          </FormItem>

          <FormItem label="设置方法">
            <p style="color: #999">
              首次查询时间：@resultTime@<br />
              查询次数：@resultNum@
            </p>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="updatas()">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>

    <SelectClient v-if="SelectClientSwitch" @Value="SelectClientVal" @close="SelectClientClose"></SelectClient>
  </div>
</template>
<script>
import { GetResultList, setResultList } from "@/api/index";
import SelectClient from "@/views/selectClient";
export default {
  data() {
    return {
      SelectClientSwitch:false,
      formItem: {
        clientcode: "",
        Ares: "",
        Bres: "",
        Cres: "",
      },
    };
  },
  components: {
    SelectClient
  },
  beforeCreate() {},
  mounted() {
    // 获取默认回复导语
    GetResultList({
      code: 1,
    }).then((res) => {
      this.formItem = {
        Ares: res.AselRes,
        Bres: res.BselRes,
        Cres: res.CselRes,
      };
    });
  },
  updated() {},
  watch: {},
  methods: {
    SelectClientClose(){
      this.SelectClientSwitch = false
    },
    SelectClientVal(value){
      this.formItem.clientcode = value
      this.SelectClientSwitch = false;
    },
    updatas() {
      setResultList({
        clientcode: this.formItem.clientcode,
        ares: this.formItem.Ares,
        bres: this.formItem.Bres,
        cres: this.formItem.Cres,
      }).then((res) => {
        if (res.code == 402) {
          this.$Notice.error({ title: "没有权限！" });
        }
        if (res == 1) {
          this.$emit("addResultList", this.formItem);
        }
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
